import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdAccountBalance, MdBusiness, MdCreditCard, MdEmail, MdMobileFriendly } from 'react-icons/md'; // Material Design email icon
import { MdPerson } from 'react-icons/md'; // Material Design email icon
import axios from 'axios';
import { web_url } from '../../constant';

const url = "http://localhost:8080/api/";
function TranslatorSignUp2() {
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setChecked(false);
        setOpen(false);
    };

    const handleAgree = () => {
        setChecked(true);
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    useEffect(() => {
        if (!localStorage.getItem('translatorsignup1')) {
            navigate('/translatorpersonaldetails');
        }
    }, []);

    const [translatorSignupDetails, setTranslatorSignupDetails] = useState(
        {
            bankName: '',
            accountName: '',
            accountNumber: '',
            branch: '',
        }
    )

    const [errors, setErrors] = useState(
        {
            noAccountName: false,
            noBankName: false,
            noAccountNumber: false,
            noBranchname: false,
            invalidAccountName: false,
            invalidBranchName: false,
            invalidBankName: false,
            invalidAccountNumber: false,
            noAgree: false
        }
    )

    const [checked, setChecked] = useState(false);

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('no pending invitation found')) {
            setError(t('t127_3'));
        } else if (err.toLowerCase().includes('email is already taken')) {
            setError(t('t92'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        localStorage.removeItem('translatorsignup1');
        navigate('/loginpage');
    };

    const handleContinue = () => {

        const numberRegex = /^\d+$/;
        const nameRegex = /^[^\d]*$/;
        let newErrors = {};

        newErrors.noAccountName = !translatorSignupDetails.accountName;
        newErrors.noBranchname = !translatorSignupDetails.branch;
        newErrors.noBankName = !translatorSignupDetails.bankName;
        newErrors.noAccountNumber = !translatorSignupDetails.accountNumber;

        const mobileRegex = /^07\d{8}$/;

        if ((translatorSignupDetails.bankName) && !nameRegex.test(translatorSignupDetails.bankName)) {
            newErrors.invalidBankName = true;
        } else {
            newErrors.invalidBankName = false;
        }

        if ((translatorSignupDetails.accountName) && !nameRegex.test(translatorSignupDetails.accountName)) {
            newErrors.invalidAccountName = true;
        } else {
            newErrors.invalidAccountName = false;
        }

        if ((translatorSignupDetails.branch) && !nameRegex.test(translatorSignupDetails.branch)) {
            newErrors.invalidBranchName = true;
        } else {
            newErrors.invalidBranchName = false;
        }

        if ((translatorSignupDetails.accountNumber) && !numberRegex.test(translatorSignupDetails.accountNumber)) {
            newErrors.invalidAccountNumber = true;
        } else {
            newErrors.invalidAccountNumber = false;
        }


        if (checked === false) {
            newErrors.noAgree = true;
        } else {
            newErrors.noAgree = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        const transDetails = JSON.parse(localStorage.getItem('translatorsignup1'));

        const translator = {
            userEmail: transDetails.email,
            userFullName: transDetails.name,
            userPassword: transDetails.password,
            contactNumber: transDetails.mobileNumber,
        };

        const paymentDet = {
            email: transDetails.email,
            name: translatorSignupDetails.accountName,
            bankName: translatorSignupDetails.bankName,
            accountNumber: translatorSignupDetails.accountNumber,
            branch: translatorSignupDetails.branch
        };

        setIsLoading(true);
        const apiUrl = `${url}auth/translators`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const filterDetails = {
            receiverEmail: transDetails.email,
            invitationStatus: "PENDING",
            userRole: "TRANSLATOR"
        }


        axios.post(`${web_url}/api/auth/register/translators`, translator, config)
            .then((response) => {
                axios.post(`${web_url}/api/auth/payments/register`, paymentDet, config).then((resPayment) => {
                    setIsLoading(false);
                    handleClickOpen2();
                }).catch((errPay) => {
                    console.log("API Response 11 err", errPay);
                    
                    if (errPay.response) {
                        if (errPay.response.data.error) {
                            handleClickOpenError(errPay.response.data.error);
                        } else if (errPay.response.data.message) {
                            handleClickOpenError(errPay.response.data.message);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    } else if (errPay.request) {
                        const errorMessage = "No response from the server. Please check your network connection.";
                    } else {
                        const errorMessage = errPay.message;
                    }
                    setIsLoading(false);
                })
            })
            .catch((err) => {
                // console.log('err2',err);
                if (err.response) {
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                } else if (err.request) {
                    const errorMessage = "No response from the server. Please check your network connection.";
                } else {
                    const errorMessage = err.message;
                }
                setIsLoading(false);
            })
    }

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center`}>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px] mt-[10px]'>
                <img src="/images/logo.svg" className="h-[150px]" alt='logo' />
                <p className="text-center text-[30px] mt-[10px]">{t('t1')}</p>
                <p className='mt-[10px] text-[16px] font-bold text-[#FDC50C]'>{t('t360')}</p>
                <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdAccountBalance size="24px" color="#8189B0" />
                    <input type="text" value={translatorSignupDetails.bankName} name="bankname" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t244')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, bankName: e.target.value
                            }))
                        }}
                    />
                </div>

                {errors.noBankName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t248')}</p>
                }

                {errors.invalidBankName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t252')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdBusiness size="24px" color="#8189B0" />
                    <input type="text" value={translatorSignupDetails.branch} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t246')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, branch: e.target.value
                            }))
                        }}
                    />
                </div>


                {errors.noBranchname &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t250')}</p>
                }

                {errors.invalidBranchName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t254')}</p>
                }


                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdCreditCard size="24px" color="#8189B0" />
                    <input type="text" value={translatorSignupDetails.accountNumber} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t245')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, accountNumber: e.target.value
                            }))
                        }}
                    />
                </div>


                {errors.noAccountNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t249')}</p>
                }

                {errors.invalidAccountNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t253')}</p>
                }


                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdPerson size="24px" color="#8189B0" />
                    <input type="text" value={translatorSignupDetails.accountName} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t243')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, accountName: e.target.value
                            }))
                        }}
                    />
                </div>


                {errors.noAccountName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t247')}</p>
                }

                {errors.invalidAccountName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t251')}</p>
                }

                <div className='flex items-center justify-center mt-[15px]'>
                    <input type='checkbox' name='regulations'
                        checked={checked} onChange={handleClickOpen} />
                    <label className='text-[14px] text-black ml-[10px]'>{t('t46')}</label>
                </div>

                {/* <button onClick={handleContinue} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button> */}
                <button onClick={handleContinue} disabled={isLoading} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                    {isLoading ? (
                        <div className="items-center justify-center flex">
                            <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                        </div>
                    ) : (
                        t('t52')
                    )}
                </button>
                {errors.noAgree &&
                    <div className='items-center justify-center flex'><p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t47')}</p></div>
                }
                <p className="text-black text-[15px] text-center mt-[10px] font-bold mb-[20px]">{t('t8_2')} <span onClick={() => (navigate('/loginas'))} className="text-[#FDC50C] hover:cursor-pointer hover:underline">{t('t25')}</span></p>


                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t53')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <p className='mt-[20px] text-black'>{t('t394')}</p>
                        <p className='mt-[20px] text-black'>{t('t395')}</p>
                        <p className='ml-[20px] text-black'>{t('t396')}</p>
                        <p className='mt-[20px] text-black'>{t('t397')}</p>
                        <p className='ml-[20px] text-black'>{t('t398')}</p>
                        <p className='mt-[20px] text-black'>{t('t399')}</p>
                        <p className='ml-[20px] text-black'>{t('t400')}</p>
                        <p className='mt-[20px] text-black'>{t('t401')}</p>
                        <p className='ml-[20px] text-black'>{t('t402')}</p>
                        <p className='mt-[20px] mb-[20px] text-black'>{t('t403')}</p>

                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t51')}
                        </Button>
                        <Button
                            onClick={handleAgree}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t50')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={open2}
                    onClose={handleClose2}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogContent className="bg-[#FFF6DA]">
                        {!isLoading &&
                            <DialogContent
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                <div className='flex flex-col justify-center items-center text-center'>
                                    <img src='/images/success.svg' alt='success' />
                                    <div className='mt-[30px]'>{t('t54')}</div>
                                </div>
                            </DialogContent>
                        }

                    </DialogContent>
                    <DialogActions
                        style={{
                            backgroundColor: '#FFF6DA',
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Button
                            onClick={() => navigate('/loginas')}
                            style={{
                                backgroundColor: '#F2AC0E',
                                color: 'white',
                                padding: '10px 20px', // px-4 py-2
                                borderRadius: '0.375rem', // rounded-md
                                fontWeight: 'bold',
                            }}
                        >
                            {t('t7')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openError}
                    onClose={handleCloseError}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t95')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {error}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseError}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t96')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default TranslatorSignUp2;